import React from "react";
import { Link } from "react-router-dom";

/**
 * BrandLogo — the ONE canonical horizontal Angel of Peace Academy logo.
 * Renders the unified /assets/logo-lockup.png with its internal proportions
 * preserved. Callers control overall width only; aspect ratio is fixed by the
 * source asset (2000×667 ≈ 3:1).
 *
 * Props:
 *   as        — "link" (default) wraps in a <Link to="/">, "static" renders bare <img>
 *   className — extra classes for the wrapper (sizing / spacing)
 *   testId    — data-testid for the wrapper
 */
const BrandLogo = ({ as = "link", className = "", testId = "brand-logo" }) => {
  const img = (
    <img
      src="/assets/logo-lockup.png?v=5"
      alt="Angel of Peace Academy"
      loading="eager"
      decoding="async"
      width={2000}
      height={667}
      className="block w-full h-auto object-contain"
    />
  );

  if (as === "static") {
    return (
      <div data-testid={testId} className={className}>
        {img}
      </div>
    );
  }

  return (
    <Link to="/" data-testid={testId} className={`inline-block ${className}`}>
      {img}
    </Link>
  );
};

export default BrandLogo;
